import { render, staticRenderFns } from "./EventRiwayatCategory.vue?vue&type=template&id=65c7c6e3&scoped=true"
import script from "./EventRiwayatCategory.vue?vue&type=script&lang=js"
export * from "./EventRiwayatCategory.vue?vue&type=script&lang=js"
import style0 from "./EventRiwayatCategory.vue?vue&type=style&index=0&id=65c7c6e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7c6e3",
  null
  
)

export default component.exports